export const CYCLE_ONE_TIME = 0;
export const CYCLE_WEEKLY = 7;
export const CYCLE_BIWEEKLY = 14;
export const CYCLE_MONTHLY = 28;
export const CYCLE_YEARLY = 365;
